import React from 'react';
import { getTrackBackground, Range as RangeSlider } from 'react-range';
import _ from 'lodash';
import { Button, Modal } from 'antd';
import { useChangeDistribution } from 'mutation/domain-warmup';

const COLORS = [
  '#96ceb5',
  '#deb1e0',
  '#b1d8a0',
  '#74aff3',
  '#dbcd9d',
  '#7cccee',
  '#ebaba7',
  '#62cdd7',
  '#adbce9',
  '#9bebde',
];

export default function DistributionChanger({
  domains,
  range,
  setRange,
  initialDistribution,
}) {
  const { mutate, isLoading } = useChangeDistribution();
  const shouldRenderSave = !_.isEqual(range, initialDistribution);
  const onSave = () => {
    Modal.confirm({
      title: 'Save new distribution?',
      onOk: () => {
        const newDistribution = {};
        domains.forEach((domain, index) => {
          const currentPercentage =
            domain.name === 'turing.com' ? 100 : range[index];
          newDistribution[domain.name] =
            (currentPercentage - (range[index - 1] || 0)) / 100;
        });
        mutate(newDistribution);
      },
    });
  };
  return (
    <div
      className="w-full flex"
      style={{
        marginTop: 20,
        overflow: 'visible',
        flexDirection: 'column',
      }}
    >
      <div className="flex items-center space-x-2">
        <h4>Distribution Percentage</h4>
        {shouldRenderSave && (
          <Button icon="save" onClick={onSave}>
            Save
          </Button>
        )}
      </div>
      <div
        style={{
          height: 100,
          width: 'calc(100% - 66px)',
          marginLeft: 33,
          marginTop: 10,
        }}
      >
        <RangeSlider
          disabled={isLoading}
          max={100}
          min={0}
          renderThumb={({ props, index }) => {
            const isTuringCom = domains[index].name === 'turing.com';
            if (isTuringCom) props.style.cursor = 'not-allowed';
            return (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '30px',
                  width: '60px',
                  borderRadius: '4px',
                  backgroundColor: '#FFF',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0px 2px 6px #AAA',
                  fontSize: 10,
                  fontWeight: 'bold',
                }}
              >
                {domains[index].name}
              </div>
            );
          }}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '6px',
                width: '100%',
                background: getTrackBackground({
                  values: range,
                  colors: COLORS,
                  min: 0,
                  max: 100,
                }),
              }}
            >
              {children}
            </div>
          )}
          values={range}
          onChange={newRange => {
            if (newRange[newRange.length - 1] !== 100) return;
            setRange(newRange);
          }}
        />
      </div>
    </div>
  );
}
